module.exports = __webpack_public_path__ + "static/assets/9a7196d23b16da2bab211148ef4a50f4.png";